import { Box, CircularProgress, Grid, Typography } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

type LoadingPageProps = {
  title?: string;
  backgroundless?: boolean;
};

const useStyles = makeStyles<Pick<LoadingPageProps, 'backgroundless'>>()((theme, props) => ({
  root: {
    color: theme.palette.primary.main,
    height: '100vh',
    backgroundColor: !props.backgroundless ? theme.palette.background.default : undefined,
  },
}));

const LoadingPage = ({ title, backgroundless = false }: LoadingPageProps) => {
  const { classes } = useStyles({
    backgroundless,
  });

  return (
    <Grid
      container
      className={classes.root}
      sx={{
        alignItems: 'center',
      }}
    >
      <Grid size={12}>
        <Grid
          container
          sx={{
            justifyContent: 'center',
          }}
        >
          <Grid size="auto">
            <Box
              sx={{
                paddingBottom: 4,
              }}
            >
              <CircularProgress size={60} />
            </Box>
          </Grid>
          {title && (
            <Grid size={12}>
              <Box
                sx={{
                  paddingBottom: 4,
                }}
              >
                <Typography align="center" variant="h4">
                  {title}
                </Typography>
              </Box>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LoadingPage;
